import { Controller } from "@hotwired/stimulus"

// Conecta-se a data-controller="ravi"
export default class extends Controller {
  static targets = ["history", "input", "send", "sidebar", "sidebarBackdrop", "sidebarOpen", "main", "mainBar"]

  connect() {
    this.historyElement = this.hasHistoryTarget
      ? this.historyTarget
      : this.element.querySelector(".ravi-room__chat-history, .ravi-gpt__history")

    this.inputElement = this.hasInputTarget
      ? this.inputTarget
      : this.element.querySelector("#textarea-message")

    this.sendButton = this.hasSendTarget
      ? this.sendTarget
      : this.element.querySelector(".ravi-room__send, .ravi-gpt__send")

    this.chatName = this.historyElement?.dataset.chatName || "Você"

    this.userAvatar = this.historyElement?.dataset.userAvatar || "/assets/images/ravi/aluno.jpeg"

    this.syncHeaderOffset()
    this._resizeHandler = () => this.syncHeaderOffset()
    window.addEventListener("resize", this._resizeHandler)

    this.setupTabScroll()
    this.scrollHistory()

    if (!this.element.classList.contains("ravi-room--gpt-tab")) {
      this.resizeInput()
    }

    this.initSidebar()
    this._sidebarMq = window.matchMedia("(max-width: 768px)")
    this._sidebarMqHandler = () => this.initSidebar()
    this._sidebarMq.addEventListener("change", this._sidebarMqHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this._resizeHandler)
    this._sidebarMq?.removeEventListener("change", this._sidebarMqHandler)
    this.teardownTabScroll()
  }

  setupTabScroll() {
    const tabRavi = this.element.closest("#tab-ravi")
    if (!tabRavi) return

    this._tabScrollHandler = () => {
      this.resizeInput()
      this.scrollHistory()
    }

    this._tabObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return

        const target = mutation.target
        if (target.classList.contains("show") && target.classList.contains("active")) {
          setTimeout(this._tabScrollHandler, 100)
        }
      })
    })

    this._tabObserver.observe(tabRavi, {
      attributes: true,
      attributeFilter: ["class"],
    })

    tabRavi.addEventListener("shown.bs.tab", this._tabScrollHandler)

    this._tabClickHandler = (event) => {
      if (event.target.closest('a[href="#tab-ravi"]')) {
        setTimeout(this._tabScrollHandler, 300)
      }
    }
    document.addEventListener("click", this._tabClickHandler)

    if (tabRavi.classList.contains("show") && tabRavi.classList.contains("active")) {
      setTimeout(this._tabScrollHandler, 200)
    }
  }

  teardownTabScroll() {
    if (this._tabObserver) this._tabObserver.disconnect()
    if (this._tabClickHandler) document.removeEventListener("click", this._tabClickHandler)

    const tabRavi = this.element.closest("#tab-ravi")
    if (tabRavi && this._tabScrollHandler) {
      tabRavi.removeEventListener("shown.bs.tab", this._tabScrollHandler)
    }
  }

  syncHeaderOffset() {
    if (this.element.classList.contains("ravi-room--gpt-tab")) return

    const header = document.getElementById("main-header")
    const height = header?.offsetHeight || 80
    document.documentElement.style.setProperty("--ravi-site-header-height", `${height}px`)
  }

  fillSuggestion(event) {
    const suggestion = event.currentTarget?.dataset?.suggestion
    if (!suggestion || !this.inputElement) return

    this.inputElement.value = suggestion
    this.resizeInput()
    this.inputElement.focus()
  }

  resizeInput() {
    if (!this.inputElement) return

    const isTab = this.element.classList.contains("ravi-room--gpt-tab")
    const maxHeight = isTab ? 120 : 200
    const minHeight = 24

    this.inputElement.style.overflowY = "hidden"
    this.inputElement.style.height = "0px"
    const nextHeight = Math.max(this.inputElement.scrollHeight, minHeight)
    const clampedHeight = Math.min(nextHeight, maxHeight)

    this.inputElement.style.height = `${clampedHeight}px`
    this.inputElement.style.overflowY = nextHeight > maxHeight ? "auto" : "hidden"
  }

  openComoUsar() {
    window.open("https://www.youtube.com/watch?v=PeSKW2BlLxc", "_blank")
  }

  toggleSidebar() {
    if (!this.hasSidebarTarget) return

    const isOpen = this.sidebarTarget.classList.toggle("is-open")
    this.sidebarTarget.classList.toggle("is-collapsed", !isOpen)
    this.syncSidebarUi(isOpen)
  }

  initSidebar() {
    if (!this.hasSidebarTarget) return

    const isMobile = window.matchMedia("(max-width: 768px)").matches
    const isTab = this.element.classList.contains("ravi-room--gpt-tab")

    if (isMobile || isTab) {
      this.sidebarTarget.classList.remove("is-open")
      this.sidebarTarget.classList.add("is-collapsed")
      this.syncSidebarUi(false)
      return
    }

    this.sidebarTarget.classList.add("is-open")
    this.sidebarTarget.classList.remove("is-collapsed")
    this.syncSidebarUi(true)
  }

  syncSidebarUi(isOpen) {
    const isMobile = window.matchMedia("(max-width: 768px)").matches

    if (this.hasMainBarTarget) {
      this.mainBarTarget.hidden = isOpen
    }

    if (this.hasSidebarBackdropTarget) {
      this.sidebarBackdropTarget.hidden = !isMobile || !isOpen
    }
  }

  async handleSendMessage(event) {
    if (event?.type === "keydown" && event.key === "Enter" && event.shiftKey) return
    if (event) event.preventDefault()

    const message = (this.inputElement?.value || "").trim()

    const name = this.historyElement?.dataset.chatName || "Você"
    if (name == "Usuário") {
      this.renderError("Cadastre-se para usar o assistente IA.")
      return
    }

    const quota = document.querySelector("[data-js='quota']")
    if (quota && quota.textContent == 0) {
      this.renderError("Sua cota diária de interações acabou.")
      return
    }

    if (quota) {
      quota.textContent = parseInt(quota.textContent, 10) - 1
    }

    if (message.length < 3) {
      this.renderError("Digite uma mensagem com pelo menos 3 caracteres.")
      return
    }

    this.toggleSendButton(true)

    try {
      const response = await fetch("/ravis", {
        method: "POST",
        body: JSON.stringify({ question: message }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      })

      const payload = JSON.parse(await response.text())

      if (payload?.message) {
        this.renderError(payload.message)
        return
      }

      this.removeEmptyState()
      this.appendUserMessage(message)
      this.renderPendingAssistantMessage()
      this.inputElement.value = ""
      this.resizeInput()
      this.scrollHistory()
    } catch (error) {
      console.error(error)
      this.renderError("Não foi possível enviar a mensagem. Tente novamente.")
    } finally {
      this.toggleSendButton(false)
    }
  }

  toggleSendButton(disabled) {
    if (this.sendButton) this.sendButton.disabled = disabled
  }

  removeEmptyState() {
    const emptyState = this.historyElement.querySelector(".chat-empty")
    if (emptyState) emptyState.remove()
  }

  appendUserMessage(text) {
    if (!this.historyElement) return

    const bubble = this.buildBubble({
      variant: "user",
      name: this.chatName,
      timestamp: new Date(),
      content: text,
      avatar: this.userAvatar,
      secondary: null,
    })

    this.historyElement.appendChild(bubble)
  }

  renderPendingAssistantMessage() {
    if (!this.historyElement) return

    if (this.pendingBubble) {
      this.pendingBubble.remove()
    }

    const loaderBubble = document.createElement("article")
    loaderBubble.className = "chat-msg chat-msg--assistant chat-msg--pending"
    loaderBubble.id = "assistant-loader"
    loaderBubble.innerHTML = `
      <div class="chat-msg__inner">
        <div class="chat-msg__avatar">
          <img src="/assets/images/ravi/rav.jpeg" alt="Rav">
        </div>
        <div class="chat-msg__bubble">
          <div class="chat-msg__content">
            <div class="chat-bubble__loader">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    `

    this.historyElement.appendChild(loaderBubble)
    this.pendingBubble = loaderBubble
    this.scrollHistory()
  }

  // Permanece disponível para uso quando a resposta chegar via ActionCable / polling
  appendAssistantMessage(text) {
    if (!this.historyElement) return

    if (this.pendingBubble) {
      this.pendingBubble.remove()
      this.pendingBubble = null
    }

    const bubble = this.buildBubble({
      variant: "assistant",
      name: "Rav",
      timestamp: new Date(),
      content: text,
      avatar: "/assets/images/ravi/rav.jpeg",
    })

    this.historyElement.appendChild(bubble)
    this.scrollHistory()
  }

  buildBubble({ variant, name, timestamp, content, avatar }) {
    const bubble = document.createElement("article")
    bubble.className = `chat-msg chat-msg--${variant}`

    const inner = document.createElement("div")
    inner.className = "chat-msg__inner"

    const bubbleEl = document.createElement("div")
    bubbleEl.className = "chat-msg__bubble"

    const contentWrap = document.createElement("div")
    contentWrap.className = "chat-msg__content"
    contentWrap.appendChild(this.formattedText(content))
    bubbleEl.appendChild(contentWrap)

    const avatarWrap = document.createElement("div")
    avatarWrap.className = "chat-msg__avatar"

    const avatarImg = document.createElement("img")
    avatarImg.src = avatar
    avatarImg.alt = name
    avatarWrap.appendChild(avatarImg)

    if (variant === "user") {
      inner.appendChild(bubbleEl)
      inner.appendChild(avatarWrap)
    } else {
      inner.appendChild(avatarWrap)
      inner.appendChild(bubbleEl)
    }

    bubble.appendChild(inner)
    return bubble
  }

  formattedText(text) {
    const fragment = document.createDocumentFragment()
    const lines = (text || "").split("\n")

    lines.forEach((line, lineIndex) => {
      const lineDiv = document.createElement("div")

      line
        .split(/(\*\*[^*]+\*\*)/)
        .filter(Boolean)
        .forEach((segment) => {
          if (segment.startsWith("**") && segment.endsWith("**")) {
            const bold = document.createElement("b")
            bold.textContent = segment.slice(2, -2)
            lineDiv.appendChild(bold)
          } else {
            const span = document.createElement("span")
            span.textContent = segment
            lineDiv.appendChild(span)
          }
        })

      if (lineIndex < lines.length - 1) {
        lineDiv.appendChild(document.createElement("br"))
      }

      fragment.appendChild(lineDiv)
    })

    return fragment
  }

  formatTimestamp(value) {
    if (!value) return "agora"

    const date = value instanceof Date ? value : new Date(value)
    const day = date.getDate()
    const monthFormatter = new Intl.DateTimeFormat("pt-BR", {
      month: "long"
    })
    const month = monthFormatter.format(date)
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1)

    const timeFormatter = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    })
    const time = timeFormatter.format(date)

    return `${day} de ${monthCapitalized}, ${time}`
  }

  scrollHistory() {
    if (!this.historyElement) return
    requestAnimationFrame(() => {
      this.historyElement.scrollTop = this.historyElement.scrollHeight
    })
  }

  renderError(message) {
    swal(
      {
        title: "Ops!",
        text: message,
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "SAIBA MAIS",
        cancelButtonText: "OK",
        closeOnConfirm: false,
        closeOnCancel: true,
      },
      function () {
        window.open(
          "https://rpconcursos.com.br/courses/assinatura-rav-i-inteligencia-artificial/nqiBWAek/DJEgOJbv",
          "_blank"
        )
      }
    )

    this.toggleSendButton(false)
  }
}